import { Action } from 'redux';
import REDUX from '../constants/REDUX';

export default function action<
  IdentifierName extends string,
  A,
  C extends(new(...args: any[]) => A) & {
    type: string;
    namespace: string;
    identifier?: IdentifierName;
  }
>(ClassAction: C): ((...args: ConstructorParameters<C>) => InstanceType<C>) & {
  type: C['type'];
  namespace: C['namespace'];
  identifier: C['identifier'];
} {
  class ExtendedClassAction extends (ClassAction as (new(...args: any[]) => Action) & {
    type: string;
    namespace: string;
    identifier?: IdentifierName;
  }) {
    static allowClass = true;
  }

  const actionFn = (...args: ConstructorParameters<C>) => {
    const result = Object.assign(new ExtendedClassAction(...args), {
      [REDUX.ACTION_NAMESPACE]: ClassAction.namespace,
      [REDUX.ACTION_IDENTIFIER]: ClassAction.identifier,
    }) as InstanceType<C>;
    return result;
  };

  actionFn.type = ExtendedClassAction.type;
  actionFn.namespace = ClassAction.namespace;
  actionFn.identifier = ClassAction.identifier;

  Object.defineProperty(actionFn, 'name', {
    value: ClassAction.name.substr(0, 1).toLowerCase() + ClassAction.name.substr(1),
  });

  return actionFn;
}
